import { EventEmitter } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { LIST_VIEW } from '../../../core/helpers/theme-config';
var OrderPageComponent = /** @class */ (function () {
    function OrderPageComponent(store) {
        this.store = store;
        this.onExpand = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.viewType = LIST_VIEW;
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(OrderPageComponent.prototype, "hasOrders", {
        get: function () {
            return this.orders && !!this.orders.length;
        },
        enumerable: true,
        configurable: true
    });
    OrderPageComponent.prototype.expand = function () {
        this.onExpand.emit();
    };
    OrderPageComponent.prototype.addCart = function (event) {
        this.onAddCart.emit(event);
    };
    return OrderPageComponent;
}());
export { OrderPageComponent };
